"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const get_phone_number_title_1 = require("@App/helpers/get-phone-number-title");
const getPhoneNumberDisplay = (userInfo) => {
    const { formattedPhoneNumber, phoneCountryCode, phoneAreaCode, phoneNumber } = userInfo;
    return formattedPhoneNumber || (0, get_phone_number_title_1.getPhoneNumberTitle)(phoneCountryCode, phoneAreaCode, phoneNumber);
};
exports.default = getPhoneNumberDisplay;
